<template>
  <div v-loading="loading" class="main-frame">
    <el-tabs v-model="localDetailType">
      <el-tab-pane label="富文本" name="rich_text">
        <el-container>
          <el-header class="banner-head" height="60px">
            <div class="head-info">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item :label="$t('category')">
                  <el-select
                    v-model="detail_category_id"
                    clearable
                    :placeholder="$t('please_choose')"
                    :loading-text="$t('loading') + '...'"
                  >
                    <el-option key :label="$t('all')" value></el-option>
                    <el-option
                      v-for="item in detail_category_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('status')">
                  <el-select
                    v-model="page_status"
                    clearable
                    :placeholder="$t('please_choose')"
                    :loading-text="$t('loading') + '...'"
                  >
                    <el-option
                      v-for="item in $common.CommonStatusList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-button
                  class="top-button"
                  size="medium"
                  type="primary"
                  round
                  @click="getDetailList()"
                  >{{ $t("filter") }}
                </el-button>
                <el-button
                  class="top-button"
                  size="medium"
                  type="primary"
                  round
                  @click="newOnClick"
                  >{{ $t("add") }}
                </el-button>
              </el-form>
            </div>
          </el-header>
          <el-main>
            <el-table
              :data="detail_list"
              style="width: 100%"
              :cell-style="$common.tableStyle"
              :header-cell-style="$common.tableStyle"
              border
              default-expand-all
            >
              <el-table-column label="#" width="80">
                <template slot-scope="scope">
                  <p style="font-weight: bold">{{ scope.$index + 1 }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('title')">
                <template slot-scope="scope">
                  <p style="font-weight: bold">{{ scope.row.title }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('category')">
                <template slot-scope="scope">
                  <p style="font-weight: bold">
                    {{
                      detail_category_map.get(scope.row.category_id)?.name ||
                      $t("none")
                    }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('last_modified_time')">
                <template slot-scope="scope">
                  <p style="font-weight: bold">
                    {{ $common.formatTimesToTime(scope.row.updated_at) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('weight')" width="160">
                <template slot-scope="scope">
                  <p style="font-weight: bold">{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('status')" width="120">
                <template slot-scope="scope">
                  <el-tag
                    style="font-weight: bold"
                    :type="$common.CommonStatusList[scope.row.status].tag"
                    effect="dark"
                    >{{ $common.CommonStatusList[scope.row.status].name }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column :label="$t('operation')" width="200">
                <template slot-scope="scope">
                  <el-button
                    style="color: #03aef9"
                    @click="editDetailOnclick(scope.row)"
                    type="text"
                    >{{ $t("edit") }}
                  </el-button>
                  <el-button
                    style="color: #f03c69"
                    @click="removeDetailOnclick(scope.row)"
                    type="text"
                  >
                    {{ $t("remove") }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer class="footer-info">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              :page-size="page_size"
              :pager-count="9"
              :total="page_total"
              :current-page="page_number"
              @current-change="(val) => handleCurrentChange('rich_text', val)"
            ></el-pagination>
          </el-footer>
        </el-container>
      </el-tab-pane>
      <el-tab-pane label="webflow" name="webflow">
        <el-row :gutter="1">
          <el-col :span="20">
            <el-form
              class="type-form webflow"
              :model="edit_model"
              label-width="130px"
            >
              <el-form-item
                :label="field.label + ':'"
                v-for="field in fileFields"
                :key="field.type"
              >
                <el-row type="flex" justify="start" :gutter="15">
                  <el-col :span="19">
                    <el-input
                      v-model="edit_model[field.textKey]"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4">
                    <div class="upload">
                      <label :for="field.type" style="margin-right: 50px">
                        <el-button
                          type="success"
                          size="large"
                          @click="downloadFile(field.type)"
                          v-show="
                            copyWebflowModel[field.textKey] &&
                            copyWebflowModel[field.textKey].length > 0
                          "
                        >
                          <span>导出{{ field.label }}文件</span>
                        </el-button>
                      </label>
                      <label :for="field.type">
                        <el-button
                          type="primary"
                          size="large"
                          @click="fileClick(field.type)"
                        >
                          <span>导入{{ field.label }}文件</span>
                          <input
                            :ref="field.type"
                            :id="field.type + '_file_upload'"
                            type="file"
                            :name="'file_upload_' + field.type"
                            @change="submitFile(field.type, $event)"
                            :accept="field.accept"
                            :multiple="field.multiple"
                            class="file_upload"
                            :size="1024 * 1024 * 5"
                          />
                        </el-button>
                      </label>

                      <el-upload
                        class="import_upload"
                        v-if="
                          edit_model[field.fileKey] &&
                          edit_model[field.fileKey].length > 0
                        "
                        action=""
                        :on-remove="(file) => handleRemove(file, field)"
                        :limit="1"
                        :file-list="edit_model[field.fileKey]"
                      ></el-upload>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="图片前缀:">
                <el-input
                  type="text"
                  v-model="edit_model.prefix_images"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="视频前缀:">
                <el-input
                  type="text"
                  v-model="edit_model.prefix_videos"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="文档前缀:">
                <el-input
                  type="text"
                  v-model="edit_model.prefix_documents"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="状态:">
                <el-select
                  v-model="edit_model.status"
                  placeholder="请选择"
                  loading-text="加载中..."
                >
                  <el-option
                    v-for="item in $common.StatusSelectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="修改说明:">
                <el-input
                  type="text"
                  placeholder="请输入修改说明"
                  v-model="edit_model.commit_info"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div style="display: flex; gap: 8px">
                  <el-button
                    type="primary"
                    @click="saveModelOnclick"
                    icon="el-icon-check"
                    >{{ $t("save") }}
                  </el-button>
                </div>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col
            :span="4"
            style="padding: 15px"
            v-if="historyList && historyList.length > 0"
          >
            <el-button type="primary" @click="dialogVisible = true"
              >查看版本历史记录列表</el-button
            >
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      class="common_dialog"
      title="版本历史记录列表"
      top="5vh"
      width="85%"
      :visible.sync="dialogVisible"
    >
      <el-main>
        <el-table
          height="550"
          :data="
            history_version_page_number === 1
              ? historyList.slice(1)
              : historyList
          "
          style="width: 100%"
          :cell-style="$common.tableStyle"
          :header-cell-style="$common.tableStyle"
          border
          default-expand-all
        >
          <el-table-column label="#" width="80">
            <template slot-scope="scope">
              <p style="font-weight: bold">
                {{ scope.$index + 1 }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="版本修改时间">
            <template slot-scope="scope">
              <el-popover placement="left" trigger="hover">
                <!-- <div slot="reference" @click="switchVersion(scope.row)">
                  {{ $common.formatTimesToTime(scope.row.updated_at) }}
                </div> -->
                <div slot="reference">
                  {{ $common.formatTimesToTime(scope.row.updated_at) }}
                </div>
                <div class="history-detail">
                  <div>
                    <div>
                      <b>{{ $t("modify_id") }}</b>
                    </div>
                    <div>{{ scope.row.id }}</div>
                  </div>
                  <div>
                    <div>
                      <b>{{ $t("modifier") }}</b>
                    </div>
                    <div>
                      {{
                        scope.row.commit_user
                          ? scope.row.commit_user.username
                          : "-"
                      }}
                    </div>
                  </div>
                  <div>
                    <div>
                      <b>{{ $t("modify_remark") }}</b>
                    </div>
                    <div>
                      {{ scope.row.commit_info ? scope.row.commit_info : "-" }}
                    </div>
                  </div>
                  <div>
                    <div>
                      <b>{{ $t("modify_time") }}</b>
                    </div>
                    <div>{{ formatTime(scope.row.created_at) }}</div>
                  </div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <!-- 动态列 -->
          <el-table-column
            v-for="(item, index) in dynamicColumns"
            :key="item.key"
            :label="item.key"
          >
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                style="font-weight: bold"
                @click.stop="
                  getItemDetail(scope.row.id, scope.row.compare_list[index].key)
                "
              >
                {{ scope.row.compare_list[index].value }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer class="footer-info">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :page-size="page_size"
          :pager-count="9"
          :total="history_version_total"
          :current-page="history_version_page_number"
          @current-change="(val) => handleCurrentChange('webflow', val)"
        ></el-pagination>
      </el-footer>
      <div slot="footer">
        <el-button type="primary" @click="dialogVisible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <HistoryCompare
      v-if="historyCompareVisible.show"
      :visible="historyCompareVisible"
      :version="compareVersion"
      :versionList="compareHistoryList"
    />
  </div>
</template>

<script>
import HistoryCompare from "@/components/historyCompare/index.vue";

const FILE_REGEX =
  /\.(png|jpg|jpeg|gif|svg|mp4|avi|mov|mkv|flv|wmv|webm|mpeg|mpg|3gp|vob|json)$/i;

const PRODUCT_DETAIL_ROUTES = {
  RichText: "/product-detail-template-rich-text",
  Features: "/product-detail-template-features",
  "360°": "/product-detail-template-3d",
  Colors: "/product-detail-template-colors",
  Specifications: "/product-detail-template-specifications",
  Gallery: "/product-detail-template-gallery",
};

export default {
  // 产品详情 - 详情面板
  name: "ProductDetailContentModule",
  components: {
    HistoryCompare,
  },
  props: {
    productId: {
      type: String,
      default: "",
    },
    operateType: {
      type: String,
      default: "",
    },
    productDetailType: {
      type: String,
      default: "rich_text", // 添加默认值
      validator: (value) => ["rich_text", "webflow", "gsap"].includes(value),
    },
  },
  data() {
    return {
      loading: false,
      page_status: 0,
      page_total: 0,
      page_size: 20,
      page_number: 1,
      localDetailType: this.productDetailType,
      detail_list: [],
      detail_category_id: "",
      detail_category_list: [],
      detail_category_map: new Map(),
      edit_model: {
        product_id: "",
        html_text: "",
        html_file: [],
        css_text: "",
        css_file: [],
        custom_css_text: "",
        custom_css_file: [],
        js_text: "",
        js_file: [],
        prefix_images: "",
        prefix_videos: "",
        prefix_documents: "",
        status: 1,
        commit_info: "",
      },
      copyWebflowModel: {},
      fileFields: this.getFileFields(),
      fileInputRefs: {},
      // 历史记录表格
      historyList: [],
      compareHistoryList: [],
      dialogVisible: false,
      historyActiveIndex: -1,
      compareVersion: null,
      historyCompareVisible: {
        show: false,
      },
      history_version_total: 0,
      history_version_page_number: 1,
    };
  },
  watch: {
    productDetailType(newVal) {
      this.localDetailType = newVal;
    },
  },
  computed: {
    dynamicColumns() {
      if (this.historyList.length === 0 || !this.historyList[0].compare_list) {
        return [];
      }
      return this.historyList[0].compare_list;
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.fileInputRefs = {};
  },
  methods: {
    async fetchData(
      url,
      params,
      successCallback,
      errorMessage = this.$t("fail_obtain_data"),
      isFileUpload = false
    ) {
      try {
        this.loading = true;
        const api = isFileUpload
          ? this.$common.httpFilePost
          : this.$common.httpPost;
        const res = await api(url, params);
        this.loading = false;
        if (res.code === "1000000") {
          try {
            successCallback(res);
          } catch (callbackErr) {
            this.handleError(callbackErr.message || errorMessage);
          }
        } else {
          this.handleError(res.message || errorMessage);
        }
        return null;
      } catch (err) {
        this.loading = false;
        this.handleError(err || errorMessage);
      }
    },
    // 统一错误处理
    handleError(message) {
      this.$message({ message, type: "error" });
    },
    init() {
      this.detail_category_map.clear();
      this.getDetailCategoryList();
      if (this.productId.length > 0) {
        this.getDetailList();
        this.getWebflowList();
      }
    },
    getFileFields() {
      return [
        { type: "html", label: "html", accept: ".html", multiple: true },
        { type: "css", label: "webflow.css", accept: ".css", multiple: false },
        {
          type: "custom_css",
          label: "产品.webflow.css",
          accept: ".css",
          multiple: false,
        },
        {
          type: "extra_css",
          label: "额外css",
          accept: ".css",
          multiple: false,
        },
        { type: "js", label: "webflow.js", accept: ".js", multiple: true },
        { type: "extra_js", label: "额外js", accept: ".js", multiple: true },
      ].map((field) => ({
        ...field,
        textKey: `${field.type}_text`,
        fileKey: `${field.type}_file`,
      }));
    },
    newOnClick() {
      const category = this.detail_category_map.get(this.detail_category_id);
      const categoryName = category && category.name;
      if (!categoryName) {
        this.$message.error(this.$t("choose_product_detail_category_warning"));
        return;
      }

      const route = PRODUCT_DETAIL_ROUTES[categoryName];
      if (route) {
        this.$router.push(
          `${route}?product_id=${this.productId}&category_id=${this.detail_category_id}`
        );
      } else {
        this.$message.error(this.$t("unknown_template_warning"));
      }
    },
    getDetailCategoryList() {
      const params = {
        status: 1,
        page_size: -1,
        page_number: 1,
      };
      this.fetchData(
        "/api/product/admin/detail/category/find/list",
        params,
        (res) => {
          this.detail_category_list = res.data.array || [];
          this.detail_category_map = new Map(
            this.detail_category_list.map((item) => [item.id, item])
          );
        },
        this.$t("fail_obtain_category_list")
      );
    },
    getDetailList(page) {
      let _me = this;
      if (page) {
        _me.page_number = page;
      }
      let params = {
        product_id: _me.productId,
        key: _me.search_key,
        status: _me.page_status,
        page_size: _me.page_size,
        page_number: _me.page_number,
        category_id: _me.detail_category_id,
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/product/admin/detail/find/list", params)
        .then((res) => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.detail_list =
              res.data.array === undefined ? [] : res.data.array;
            _me.page_total = res.data.total;
            _me.$emit("detail-list-change", _me.detail_list);
          } else {
            _me.$message({
              message: res.message || this.$t("fail_obtain_data"),
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || this.$t("fail_obtain_data"),
            type: "error",
          });
        });
    },
    editDetailOnclick(model) {
      const route = PRODUCT_DETAIL_ROUTES[model.category_name];
      if (route) {
        this.$router.push(
          `${route}?product_id=${encodeURIComponent(
            model.product_id
          )}&category_id=${encodeURIComponent(
            model.category_id
          )}&id=${encodeURIComponent(model.id)}`
        );
      } else {
        this.$message.error(this.$t("unknown_template_warning"));
      }
    },
    removeDetailOnclick(model) {
      let _me = this;
      _me
        .$confirm(this.$t("delete_warning") + "?", this.$t("tip"), {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          type: "warning",
        })
        .then(() => {
          _me.removeItem(model);
        })
        .catch(() => {});
    },
    removeItem(model) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: model.id,
      };
      _me.$common
        .httpPost("/api/product/admin/detail/delete", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            _me.$message.success(this.$t("delete_success"));
            _me.getDetailList();
          } else {
            _me.$message({
              message: res.message || this.$t("fail_obtain_data"),
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || this.$t("fail_obtain_data"),
            type: "error",
          });
        });
    },
    handleCurrentChange(key, val) {
      if (key === "rich_text") {
        this.page_number = val;
        this.getDetailList();
      } else if (key === "webflow") {
        this.history_version_page_number = val;
        this.getHistoryList();
      }
    },
    getWebflowList() {
      let _me = this;
      let params = {
        product_id: _me.productId,
        page_size: 1,
        page_number: -1,
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/product/admin/webflow/find/list", params)
        .then((res) => {
          _me.loading = false;
          if (res.code === "1000000") {
            if (res.data.array && res.data.array.length > 0) {
              const model = res.data.array[0];
              this.copyWebflowModel = JSON.parse(JSON.stringify(model));
              this.edit_model = {
                ...model,
                html_file: model.html_file || [],
                css_file: model.css_file || [],
                custom_css_file: model.custom_css_file || [],
                js_file: model.js_file || [],
              };
              _me.$emit("detail-webflow-list-change", res.data.array);
              _me.getHistoryList();
            }
          } else {
            _me.$message({
              message: res.message || "获取数据失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || "获取数据失败",
            type: "error",
          });
        });
    },
    handleRemove(file, field) {
      const file_list = this.edit_model[field.fileKey];
      const index = file_list.findIndex(
        (item) => item.lastModified === file.lastModified
      );
      if (index > -1) {
        file_list.splice(index, 1);
        this.emptyInput(field.type);
      }
    },
    emptyInput(type) {
      const element = document.getElementById(`${type}_file_upload`);
      if (element) element.value = "";
    },
    saveModelOnclick() {
      if (this.edit_model.id !== undefined && this.edit_model.id.length > 0) {
        this.updateOneModel();
      } else {
        this.addNewModel();
      }
    },
    processedDomain(domain) {
      if (!domain) return "";
      const domainParts = domain.split("/");
      const lastSegment = domainParts[domainParts.length - 1];
      const isFile = lastSegment && FILE_REGEX.test(lastSegment);
      return isFile ? domainParts.slice(0, -1).join("/") : domain;
    },
    // 构建公共 params
    buildBaseParams(editModel, productId) {
      const formData = new FormData();

      // 必填字段
      formData.append("product_id", productId);

      // 可选字段 - 增加undefined过滤
      const optionalFields = {
        html_text: editModel.html_text,
        css_text: editModel.css_text,
        custom_css_text: editModel.custom_css_text,
        extra_css_text: editModel.extra_css_text,
        js_text: editModel.js_text,
        extra_js_text: editModel.extra_js_text,
        prefix_images: this.processedDomain(editModel.prefix_images),
        prefix_videos: this.processedDomain(editModel.prefix_videos),
        prefix_documents: this.processedDomain(editModel.prefix_documents),
        status: editModel.status,
        commit_info: editModel.commit_info,
      };

      // 自动过滤undefined字段
      Object.entries(optionalFields).forEach(([key, value]) => {
        if (value !== undefined) {
          formData.append(key, value);
        }
      });

      // 添加文件
      this.fileFields.forEach((field) => {
        const files = editModel[field.fileKey];
        if (files && files.length > 0) {
          Array.from(files).forEach((file) => {
            formData.append(field.type + "_file", file);
          });
        }
      });

      if (editModel.id) {
        formData.append("id", editModel.id);
        formData.append(
          "last_updated_at",
          this.$common.formatTimestampLongZone(editModel.updated_at)
        );
      }

      return formData;
    },
    // 统一处理新增/更新逻辑
    handleWebflowOperation(isUpdate = false) {
      const _me = this;
      const baseParams = this.buildBaseParams(_me.edit_model, _me.productId);
      const url = isUpdate
        ? "/api/product/admin/webflow/update"
        : "/api/product/admin/webflow/add";
      const callback = (res) => {
        _me.$message.success(res.message || "操作成功");
        _me.getWebflowList();
        _me.resetFiles();
      };
      let flag =
        baseParams.get("prefix_images").length === 0 &&
        baseParams.get("prefix_videos").length === 0;
      if (flag) {
        _me.$message({
          message: "请正确填写图片或视频前缀的任意一个",
          type: "error",
        });
        return;
      }
      this.fetchData(url, baseParams, callback, "", true);
    },
    // 更新模型
    updateOneModel() {
      this.handleWebflowOperation(true);
    },
    // 新增模型
    addNewModel() {
      this.handleWebflowOperation(false);
    },
    submitFile(type, e) {
      const files = e.target.files;
      if (files.length === 0) return; // 防止意外清空已上传文件
      this.edit_model[`${type}_file`] = Array.from(files);
    },
    resetFiles() {
      this.fileFields.forEach((field) => {
        this.edit_model[field.fileKey] = [];
      });
    },
    // 导出文件
    downloadFile(type) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: _me.edit_model.id,
        text_name: `${type}_text`,
      };
      _me.$common
        .httpPostBlob("/api/product/admin/webflow/export", params)
        .then((res) => {
          let content_disposition = decodeURI(
            res.headers["content-disposition"]
          ); //解码后获取文件名字
          content_disposition = content_disposition.substring(
            content_disposition.indexOf("utf-8") + 7
          );
          res = res.data;
          _me.loading = false;
          if (res && res.size > 0) {
            const blob = new Blob([res]);
            const elink = document.createElement("a");
            elink.download = content_disposition;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
          } else {
            _me.$message({
              message: res.message || this.$t("fail_obtain_data"),
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || this.$t("fail_obtain_data"),
            type: "error",
          });
        });
    },
    // 统一文件点击方法
    fileClick(type) {
      const fileInput = this.$refs[`${type}`][0];
      fileInput && fileInput.click();
    },
    formatTime(text) {
      const value = new Date(text);
      if (value.toString() === "Invalid Date") {
        return text;
      } else {
        return this.$common.formatTimesToTime(value);
      }
    },
    // 历史记录
    getHistoryList() {
      let _me = this;
      const params = {
        product_webflow_id: this.edit_model.id,
        page_size: _me.page_size,
        page_number: _me.history_version_page_number,
      };
      this.$common
        .httpPost("/api/product/admin/webflow/history/find/list", params)
        .then((res) => {
          if (res.code === "1000000") {
            this.historyList = res.data.array || [];
            this.historyActiveIndex = this.historyList.length - 1;
            this.history_version_total = res.data.total;
            this.lastUpdatedAt = res.data.updated_at;
            if (this.historyList.length > 0) {
              this.historyList.forEach((item) => {
                // 生成以_had_changed结尾的属性的字段生成数组，而且数组每项组合成一个对象，对象的key为字段名，value为字段值截取以_had_changed组成的数组的第一项，如果为true则为对比，否则为空
                item.module_json = {};
                let compare_list = [];
                for (let key in item) {
                  if (
                    key.endsWith("_had_changed") &&
                    key !== "status_had_changed"
                  ) {
                    compare_list.push({
                      key: key.split("_had_changed")[0],
                      value: item[key] === true ? "对比" : "",
                    });
                  }
                }
                item.compare_list = compare_list;
              });
            }
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || this.$t("fail_obtain_data"),
            type: "error",
          });
        })
        .finally(() => (this.loading = false));
    },
    getItemDetail(id, key) {
      let _me = this;
      this.compareVersion = id;
      const params = {
        id,
        // show_fields: key,
      };
      this.$common
        .httpPost("/api/product/admin/webflow/history/find/id", params)
        .then((res) => {
          if (res.code === "1000000") {
            let itemInfo = res.data || {};
            let arr = JSON.parse(JSON.stringify(this.historyList));
            arr[0] = {
              ...arr.find((item) => item.id === id),
              module_json: JSON.stringify({
                rich_text: itemInfo[key],
              }),
            };
            arr[1] = {
              ...[...this.historyList][0],
              module_json: JSON.stringify({
                rich_text: this.edit_model[key],
              }),
            };
            this.compareHistoryList = arr.slice(0, 2);
            this.historyCompareVisible.show = true;
          } else {
            _me.$message({
              message: res.message || this.$t("fail_obtain_data"),
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || this.$t("fail_obtain_data"),
            type: "error",
          });
        });
    },
    // 版本回退
    // switchVersion(value) {
    //   console.log(value);
    //   this.$confirm(this.$t("confirm_switch_version") + "?", this.$t("tip"), {
    //     confirmButtonText: this.$t("confirm"),
    //     cancelButtonText: this.$t("cancel"),
    //     type: "warning",
    //   }).then(() => {
    //     try {
    //       const moduleJson = JSON.parse(value.module_json);
    //       this.historyActiveIndex = this.historyList.findIndex(
    //         (item) => item.id === value.id
    //       );
    //       this.moduleJson.rich_text = moduleJson.rich_text;
    //     } catch (error) {
    //       this.$message.error(`${error.message}`);
    //     }
    //   });
    // },
  },
};
</script>

<style scoped>
/* .footer-info布局通用代码 */
.footer-info {
  height: 60px;
  background: #f1f1f1;
  display: flex;
  align-items: center;
}

/* 只有一个子元素时 */
.footer-info > :only-child {
  margin-left: auto;
}

/* 有两个子元素时 */
.footer-info > :nth-child(2) {
  margin-left: auto;
}
.file_upload {
  display: none;
}

.upload {
  display: flex;
}

.import_upload {
  line-height: 20px;
}

.import_upload >>> .el-upload {
  display: none;
}

.webflow .el-form-item {
  height: 40px !important;
}

/* 历史版本记录 */
.history {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  align-items: start;
}

.history-title {
  font-size: 14px;
  font-weight: 800;
  padding: 15px 10px;
}

.history-content {
  height: 100%;
  overflow-y: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  padding: 10px;
}

.history-item:hover {
  background: #f1f1f1;
  cursor: pointer;
}

.history-detail {
  font-size: 13px;
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 5px;
}
</style>